import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name"]

interface INavParams {
  companyId: string
  fid: string
  groupId: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Updates',
  props: {
    navId: null,
    navParams: null
  },
  setup(__props: any) {

const props = __props as {
  navId: number
  navParams: INavParams
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("micro-app", {
    name: 'updates' + props.navId,
    key: props.navParams?.fid || props.navParams.groupId,
    "disable-scopecss": ""
  }, null, 8, _hoisted_1))
}
}

})